import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Loader from 'components/common/loader/Loader';
import { isAdvertiserRole, isPublisherRole } from 'store/selectors';
import { globalAPI } from 'services/global.service';

export const LoginRedirect = () => {
  const isAdvertiser = useSelector(isAdvertiserRole);
  const isPublisher = useSelector(isPublisherRole);
  const { data, isFetching } = globalAPI.useDetectNewUserQuery(undefined, {
    skip: isAdvertiser || !isPublisher,
    refetchOnMountOrArgChange: true,
  });

  if (isFetching) return <Loader.Global delay={0} />;

  const isNewPublisher = data?.isRedirectToManageApps || data?.isNewUser;
  const destination =
    isPublisher && !isAdvertiser && isNewPublisher ? '/manage_apps' : '/dashboard';

  return <Navigate to={destination} replace />;
};
